<template>
  <div class="card h-100">
    <div class="card-header bg-primary text-white">
      <h5 class="mb-0">
        <i class="fas fa-globe-americas me-2"></i>Répartition par pays
      </h5>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <ChartJs 
        v-else 
        type="pie" 
        :data="chartData" 
        :options="chartOptions" 
        class="h-100"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CountryDistributionChart',
  data() {
    return {
      loading: true,
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            labels: {
              boxWidth: 15,
              padding: 15
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || '';
                const value = context.raw || 0;
                const total = context.chart.getDatasetMeta(0).total;
                const percentage = Math.round((value / total) * 100);
                return `${label}: ${value} (${percentage}%)`;
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.axios.get('/api/stats/freelancers/countries');
        this.prepareChartData(response.data);
      } catch (error) {
        console.error('Error fetching country distribution:', error);
      } finally {
        this.loading = false;
      }
    },
    prepareChartData(data) {
      const countries = data.map(item => item.pays);
      const counts = data.map(item => item.total);
      const backgroundColors = this.generateColors(data.length);

      this.chartData = {
        labels: countries,
        datasets: [
          {
            data: counts,
            backgroundColor: backgroundColors
          }
        ]
      };
    },
    generateColors(count) {
      const colors = [];
      const hueStep = 360 / count;
      
      for (let i = 0; i < count; i++) {
        const hue = Math.floor(i * hueStep);
        colors.push(`hsl(${hue}, 70%, 60%)`);
      }
      
      return colors;
    }
  }
}
</script>

<style scoped>
.card-body {
  min-height: 300px;
}
</style>